if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector(".js-product-form");
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector("side-cart");
        this.submitBtn = this.querySelector('[name="add"]');
        if (document.querySelector('.navigation-vrac__content [name="add"]')) {
          this.submitBtn2 = document.querySelector(
            '.navigation-vrac__content [name="add"]'
          );
        }

        if (theme.settings.afterAtc !== "no-js") {
          this.addEventListener("submit", this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === "product-signup_form") return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute("aria-disabled", "true");
      this.submitBtn.classList.add("is-loading");
      this.submitBtn2?.setAttribute("aria-disabled", "true");
      this.submitBtn2?.classList.add("is-loading");

      const formData = new FormData(this.form);
      let sections = "cart-icon-bubble";
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer
          .closest(".shopify-section")
          .id.replace("shopify-section-", "")}`;
      }

      formData.append("sections_url", window.location.pathname);
      formData.append("sections", sections);

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      };

      if (document.querySelector(".product-option__container.actif")) {
        //  add the product en plus de celui du form  to the cart in the same time on only one quantity
        const id = document
          .querySelector(".product-option__container.actif option:checked")
          .getAttribute("data-option-product-id");
        const quantity = 1;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: id,
                quantity: quantity,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Success:", data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      try {
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        console.log(response);
        const data = await response.json();
        const error =
          typeof data.description === "string"
            ? data.description
            : data.message;

        let _item = {
          AddedItemProductName: data.product_title,
          AddedItemProductID: `${data.product_id}`,
          AddedItemSKU: data.sku,
          AddedItemPrice: data.final_price / 100,
          AddedItemURL: data.url,
          AddedItemImageURL: data.image,
          $use_ip: true,
          $is_session_activity: true,
        };

        setTimeout(
          function () {
            this.productAdded(_item);
          }.bind(this),
          3000
        );

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === "page") {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          // document.querySelector('#cart-icon-bubble') ? ProductForm.updateCartIcon(data) : null;

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer) quickAddDrawer.addedToCart();
          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              document.querySelector("side-cart").dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:refresh", {
                  detail: {
                    cart: data,
                    new_item_added: true,
                    open: true,
                  },
                })
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const sidecart = document.querySelector("side-cart");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else {
                  sidecart.refreshCartAndOpen(true);
                }
              }
            }
          }, 0);
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: true,
            detail: {
              error: this.errorMsg.textContent,
            },
          })
        );
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add("is-success");
        this.submitBtn.removeAttribute("aria-disabled");
        this.submitBtn2?.classList.add("is-success");
        this.submitBtn2?.removeAttribute("aria-disabled");
        setTimeout(() => {
          this.submitBtn.classList.remove("is-loading");
          this.submitBtn.classList.remove("is-success");
          this.submitBtn2?.classList.remove("is-loading");
          this.submitBtn2?.classList.remove("is-success");
        }, 1400);
      }
    }

    // /**
    //  * Updates the cart icon count in the header.
    //  * @param {object} response - Response JSON.
    //  */
    // static updateCartIcon(response) {
    //   const cartIconBubble = document.getElementById("cart-icon-bubble");
    //   if (cartIconBubble) {
    //     cartIconBubble.innerHTML = response.sections["cart-icon-bubble"];
    //   }
    // }

    productAdded(_item) {
      fetch(`${window.location.origin}/cart.js`).then((res) =>
        res
          .clone()
          .json()
          .then((data) => {
            var cart = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount,
              original_total_price: data.original_total_price / 100,
              items: data.items,
            };

            if (_item !== "undefined") {
              cart = Object.assign(cart, _item);
            }
          })
      );
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  customElements.define("product-form", ProductForm);
}
